import * as THREE from 'three'
import html2canvas from 'html2canvas';
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min'
export default class Label extends THREE.Object3D {
    constructor(target, height, width) {
        super()
        this.target = target
        this.height = height
        this.width = width
        this.update()
    }

    update() {
        if (this.updating) return
        this.updating = true
        if (this.plane)
            new TWEEN.Tween(this.plane.scale)
                .to(new THREE.Vector3(0, 0, 0), 500)
                .easing(TWEEN.Easing.Cubic.InOut)
                .start();
        setTimeout(() => {
            this.clear()
            this.load()
            this.updating = false
        }, 500)
    }

    load() {
        const { target, height, width } = this
        html2canvas(document.querySelector(target)).then(canvas => {
            const texture = new THREE.CanvasTexture(canvas)
            const material = new THREE.MeshStandardMaterial({
                map: texture,
                transparent: true,
                color: 'white',
                opacity: 1
            })
            this.canvasTexture = texture
            this.canvasMaterial = material
            const geometry = new THREE.PlaneBufferGeometry(width, height)
            const plane = new THREE.Mesh(geometry, material)
            this.plane = plane
            plane.receiveShadow = true;
            this.add(plane)
            plane.scale.set(0, 0, 0)
            new TWEEN.Tween(this.plane.scale)
                .to(new THREE.Vector3(1, 1, 1), 500)
                .easing(TWEEN.Easing.Cubic.InOut)
                .start();
        });
    }
}
